import { ReactNode } from 'react';

import styles from './styles.module.css';

type Props = {
  // ReactNode et non string : certains messages portent un lien (numéro du Service
  // Client cliquable) et ne peuvent donc pas se réduire à du texte.
  text: ReactNode;
};

const FormTextError = ({ text }: Props) => {
  return (
    <div className={styles.formTextErrorBox}>
      <i className="totem-icon totem-icon-cross-circle" />
      <p className={styles.formTextErrorText}> {text} </p>
    </div>
  );
};

export default FormTextError;
